import BrowseAllLink from "components/apiDocs/ApiSidebar/BrowseAllLink";
import GettingStartedDropdown from "components/apiDocs/ApiSidebar/GettingStartedDropdown";
import {
  ApiData,
  Endpoint,
} from "models/apiDocumentation/apiDocumentationModels";
import React, { useState } from "react";

import ApiCategoryDropdown from "./ApiCategoryDropdown";
import ApiSearchBar from "./ApiSearchBar";
import { StyledSidebar } from "./style";

export interface ActivePagePathProps {
  activePagePath: string | null;
}

interface Props extends ActivePagePathProps {
  apiData: ApiData;
  selectedEndpoint: Endpoint | null;
}

const ApiSidebar: React.FC<Props> = ({
  apiData,
  selectedEndpoint,
  activePagePath,
}) => {
  // Adding this state as a key to ApiSearchBar ensures it gets re-rendered on
  // every search. This is required due to some unpredictable behaviour from
  // react-select. If the search bar doesn't get re-rendered, performing a search
  // leaves the search bar blank. Clicking on the bar restores the input text,
  // but clearing the term shows an incorrect placeholder. Re-rendering restores
  // the Select component to its default working state
  const [searchBarKey, setSearchBarKey] = useState<number>(0);

  return (
    <StyledSidebar key={activePagePath}>
      <ApiSearchBar
        apiData={apiData}
        searchBarKey={searchBarKey}
        setSearchBarKey={setSearchBarKey}
        key={searchBarKey}
      />
      <GettingStartedDropdown activePagePath={activePagePath} />
      <BrowseAllLink activePagePath={activePagePath} />
      {apiData.tags.map((tag) => (
        <ApiCategoryDropdown
          key={tag.name}
          categoryName={tag.name}
          apiData={apiData}
          selectedEndpoint={selectedEndpoint}
        />
      ))}
    </StyledSidebar>
  );
};

export default ApiSidebar;
